import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getServicesRepository, { ServiceRequest, ServiceResponse } from './getServices.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getServices = createAsyncThunk('getServices', async (params: ServiceRequest): Promise<ServiceResponse[]> => {
  return await getServicesRepository(params).catch((error) => {
    throw error;
  });
});

const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServices.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getServices.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      },
    );
    builder.addCase(getServices.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
